module.exports = __webpack_public_path__ + "img/pages_hero.jpg?4f94838a380d0a9957dac7789cea5eb9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/pages_hero.jpg
// module id = 305
// module chunks = 0